export default __webpack_public_path__ + "static/media/time.b89e15aa.svg";